import { css, keyframes } from '@emotion/core'
import styled, { Theme } from '@themes/theme'
import { mqMin, PCMaxWidth } from '@styles/base.style'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const effectsAni = keyframes`
//   0% {
//     top: 10px;
//     left: 3px;
//     transform: rotate(0deg);
//   }
//   25% {
//     top: 0;
//     left: 10px;
//     opacity: .8;
//   }
//   70% {
//     top: 2px;
//     left: 40px;
//     opacity: 0;
//     transform: rotate(150deg);
//   }
//   100% {
//     opacity: 0;
//   }
// `
const bagAni = keyframes`
  0%, 85%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
`
// header
export const MainHeader = styled.div`
  z-index: 6; /* 퀵 메뉴 z-index: 4 */
  position: fixed;
  top: -1px;
  left: 0;
  width: 100%;
  min-height: 30px;
  height: 41px;
  padding: 0 12px;
  background: ${props => props.theme.color.mainBg};

  &.filter-page-header {
    .header-notice {
      display: none !important;
    }
  }

  .adv-logo {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 50%;
    width: auto;
    height: 40px;
    text-align: center;
    transform: translate(-50%, -50%);

    svg {
      width: auto;
      height: 16px;

      path {
        fill: ${props => props.theme.color.themeTxt} !important;
      }
    }
  }

  .adv-txt {
    display: none;
  }

  .menu-btn {
    position: absolute;
    left: 0;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    border: 0;
    clip: rect(0, 0, 0, 0);

    & + label {
      position: relative;
      top: -1px;
      width: 30px;
      height: 40px;
      background: none;
      border-radius: 0;
      float: left;

      .menu-ico {
        &-line {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 19px;
          height: 2px;
          background: ${props => props.theme.color.themeTxt};
          border-radius: 50px;
          transform: translate(-50%, -50%);
          transition: all .3s;

          &::before, &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            width: 100%;
            height: 2px;
            background: ${props => props.theme.color.themeTxt};
            border-radius: 50px;
            transition: all .3s;
          }

          &::before {
            top: -6px;
          }

          &::after {
            top: 6px;
          }
        }
      }
    }
  }

  .mobile-home-ico {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 40px;
    margin-left: 6px;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 17px;
      height: auto;
      transform: translate(-50%, -55%);

      path {
        fill: ${props => props.theme.color.yellow};

        &.dark {
          fill: ${props => props.theme.color.mainBg};
        }
      }
    }

    span {
      position: absolute;
      left: 0;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      border: 0;
      clip: rect(0, 0, 0, 0);
    }
  }

  /* header right button */

  .header-btn {
    float: right;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 40px;
    line-height: 3rem;
    background: none;

    & > svg {
      width: 15px;
      height: auto;
    }

    &.profile-btn:not(.pc) {
      position: relative;
      .progress-bar-wrap {
        width: 54px;
        height: 54px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .progress-bar {
          transform: rotate(-90deg);
          .bg {
            stroke: ${props => props.theme.color.subColor2};
            stroke-width: 2px;
          }
          .processing {
            stroke: ${props => props.theme.color.modalOrange};
            stroke-width: 2px;
              //&.achieve {
              //  stroke: url(#gradient);
              //  filter: url(#drop-shadow);
              //}
          }
        }
      }
      .available-profile-bg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 58px;
        height: 58px;
      }
      &::before, &::after {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
      }

      //&::before {
      //  width: 30px;
      //  height: 30px;
      //  background: linear-gradient(135deg, #c9c9c9, #506070);
      //}

      &::after {
        width: 28px;
        height: 28px;
        background: ${props => props.theme.color.mainBg};
        transform: translate(-50%, -50%) scale(1.01);
      }
    }

    .profile-img {
      z-index: 1;
      position: relative;
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      overflow: hidden;
      background: #eee;

      &.custom {
        background: none;
      }

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: auto;

        &.custom-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        // header의 프로필 이미지만 확대해서 보여주기 (기본 스킨만)
        &.zoom-img {
          width: 170%;
          height: 170%;
          transform: translate(-50%, -35%);
        }
      }
    }
  }

  /* pc */

  &.pc-main-header {
    /* // TODO */
    position: fixed; /* position: absolute로 할 경우 edge에서 스크롤 생기는 현상 발생 */
    left: auto;
    width: 100%;
    max-width: ${PCMaxWidth};
    height: 60px;
    padding-left: 193px;
    padding-right: 0;
    /* PC웹 스크롤 추가로 인해 추가한 z-index값 [이슈링크](https://task.zempublic.co.kr/view.php?id=9598) */
    z-index: 2;

    &::before {
      content: '';
      display: block;
      position: fixed;
      top: 60px;
      left: 50%;
      width: 100%;
      border-bottom: 1px solid #393C46;
      transform: translate(-50%, 0);

      ${mqMin[7]} {
        width: 100vw;
      }
    }

    .pc-header-wrap {
      width: 1240px;
      border: 1px solid blue;
    }

    .adv-logo {
      float: left;
      position: relative;
      left: 0;
      top: 0;
      transform: none;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 78px;
      height: 100%;
      margin: 0 7px 0 26px;

      svg {
        width: 100%;
        height: auto;
        transform: translateY(1px);

        path {
          fill: ${props => props.theme.color.themeTxt} !important;
        }
      }
    }

    .adv-txt {
      float: left;
      display: block;
      line-height: 4rem;
      margin-top: 12px;
      font-size: 21px;
    }

    .menu-btn {
      & + label {
        z-index: 100;
        top: 0;
        width: 62px;
        height: 60px;
        //background: none;
        .menu-ico {
          &-line {
            width: 26px;
            height: 3px;

            &::before, &::after {
              height: 3px;
            }

            &::before {
              top: -9px;
            }

            &::after {
              top: 9px;
            }
          }
        }
      }

      &:checked + label {
        .menu-ico {
          &-line {
            background: none;

            &::before {
              transform: translateY(9px) rotate(45deg);
            }

            &::after {
              transform: translateY(-9px) rotate(-45deg);
            }
          }
        }
      }
    }

    .header-btn {
      width: 77px;
      height: 30px;
      margin: 15px 10px 15px 0;
      font-size: ${props => props.theme.font.large};
      color: ${props => props.theme.color.mainBg};
      background: ${props => props.theme.color.themeTxt};

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;

        &.message {
          width: 18px;

          path:not(.fill) {
            fill: ${props => props.theme.color.mainBg};
          }
        }

        &.profile {
          width: 13px;

          svg {
            top: 50%;

            path {
              fill: ${props => props.theme.color.mainBg};
            }
          }
        }
      }

      &.message-btn {
        margin-right: 10px;
      }

      &.login-btn {
        border-radius: 50px;
        line-height: 3.2rem;
      }

      &.sign-up {
        color: ${props => props.theme.color.themeTxt};
        background: none;
        border: 1px solid ${props => props.theme.color.themeTxt};
      }

      /* 서랍메뉴가 열렸을 때 우측 버튼 비활성화 처리 */

      &.side-menu-expand {
        opacity: .1;

        &::before {
          display: none;
        }

        .am-badge {
          display: none;
        }
      }

      &.charge-btn {
        width: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        background: none;

        .effects {
          position: absolute;
          top: 2px;
          left: 3px;
          width: 50px;
          height: 50px;
          border-radius: 50%;

          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: ${props => props.theme.color.themeTxt};
            opacity: .8;
          }
        }

        .bag-img {
          position: absolute;
          top: -5px;
          left: 7px;
          width: 38px;
          height: 39px;
          transform: translate3d(0, 0, 0); /* 이미지가 뿌옇게 나오는 현상 해결 */
        }

        //noinspection CssInvalidPropertyValue
        .bg-img {
          image-rendering: -webkit-optimize-contrast;
        }

        .bg-effect {
          opacity: 0;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: inherit;
          background: rgba(255, 255, 255, .1);
        }

        #tsparticles {
          position: relative;
          width: 90px;
        }

        &:hover {
          .bag-img {
            animation: ${bagAni} 1s infinite ease-in-out;
          }
        }
      }
    }

    .logo-wrap {
      position: relative;
    }
  }

  // 눈 내리는 효과
  .particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;

    &.pc {
      height: 60px;
    }
  }
`

export const HeaderProfileBtn = (theme: Theme) => css`
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 40px;
  line-height: 3rem;
  background: none;
  & > svg {
    width: 15px;
    height: auto;
  }
  &:not(.pc) {
    &::before, &::after {
      content:'';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
    }
    &::before {
      width: 30px;
      height: 30px;
      background: linear-gradient(135deg, #c9c9c9, #506070);
    }
    &::after {
      width: 28px;
      height: 28px;
      background: ${theme.color.mainBg};
      transform: translate(-50%, -50%) scale(1.01);
    }
  }
  .profile-img {
    z-index: 1;
    position:relative;
    display:block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    background: #eee;
    &.custom {
      background: none;
    }
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: auto;
      &.custom-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      // header의 프로필 이미지만 확대해서 보여주기 (기본 스킨만)
      &.zoom-img {
        width: 170%;
        height: 170%;
        transform: translate(-50%, -35%);
      }
    }
  }
  &.home-profile {
    position: absolute;
    top: 0;
    right: 12px;
    .progress-bar-wrap {
      width: 54px;
      height: 54px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .progress-bar {
        transform: rotate(-90deg);
        .bg {
          stroke: ${theme.color.subColor2};
          stroke-width: 2px;
        }
        .processing {
          stroke: ${theme.color.modalOrange};
          stroke-width: 2px;
          //&.achieve {
          //  stroke: url(#gradient);
          //  filter: url(#drop-shadow);
          //}
        }
      }
    }
    .available-profile-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 58px;
      height: 58px;
    }
  }
`

export const right = css`
  float: right;
  position: relative;
  top: -3px;
  width: auto;
  height: 100%;
  overflow: visible;
`
// export const LoginBtnStyle = css`
//   width: 62px;
//   height: 30px;
//   padding: 0;
//   line-height: 3rem;
//   &:hover::before {
//     transform: scaleX(1.1) scaleY(1.3);
//   }
// `
export const HeaderIcoStyle = (theme: Theme) => css`
  float: right;
  width: 30px;
  height: 30px;
  margin-left: 6px;
  line-height: 3rem;
  background: none;
  &.alert {
    /* 알림 아이콘 눌렀을 떄 css */
    &.click {
      path {
        fill: ${theme.color.primary};
      }
    }
  }
  &.login-btn {
    width: 50px;
    color: ${theme.color.mainBg};
    background: ${theme.color.themeTxt};
    border-radius: 50px;
    height: 25px;
    line-height: 0;
    margin-top: 8px;
  }
`

// export const IconStyle = styled.span`
//   position: relative;
//   svg {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     width: 18px;
//     height: 18px;
//     transform: translate(-50%, -40%);
//     path {
//       fill: ${props => props.theme.color.themeTxt};
//       transition: all 0.3s;
//     }
//   }
//   &.alert {
//     margin: 0;
//   }
//   &.profile {
//     svg {
//       width: 16px;
//     }
//   }
//   &.message {
//     margin: 0;
//   }
// `
// poopover
// export const ListBtnStyle = css`
//   width: 100%;
//   height: auto;
//   padding: 0;
//   border: none;
//   text-align: left;
//
//   &::before {
//     display: none;
//   }
// `
// export const ListRowStyle = css`
//   position: relative;
//   width: 100%;
//   line-height: 1.4rem;
// `
// export const DummyStyle = styled.span`
//   width: 14px;
//   svg {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-70%, -50%);
//   }
// `
// export const PopoverDate = styled.span`
//   display: block;
//   color: ${props => props.theme.color.disableTxt};
//   font-size: ${props => props.theme.font.small};
// `
// export const PopoverTitle = styled.p`
//   display: block;
//   width: 100%;
//   color: ${props => props.theme.color.mainBg};
// `
// export const PopoverContent = styled.p`
//   width: 100%;
//   color: ${props => props.theme.color.disableTxt};
//   font-size: ${props => props.theme.font.small};
// `
export const LogoWrap = styled.span`
  .logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: 21px;
  }
  .adv-logo {
    svg path {
      fill: #fff !important;
    }
    // 크리스마스 시즌 연출
    .logo-effect {
      position: absolute;
      top: calc(50% + -3px);
      left: 50%;
      transform: translate(-50%, -50%);
      width: 56px;
      height: auto;
      &.pc {
        width: 78px;
      }
    }
  }
`
